import { CSSProperties, Ref, forwardRef } from 'react';
import { CardProps } from '@ets/design-system';
import { Card } from '_common/lib/components';

import Header from './Header/Header';
import Body from './Body/Body';
import Footer from './Footer/Footer';
import DueDateBanner from './DueDateBanner/DueDateBanner';

const BaseCard = forwardRef(
  (
    { children, ...props }: CardProps & { flat?: boolean; width?: CSSProperties['width'] },
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <div
        ref={ref}
        style={{
          width: '100%',
          maxWidth: '43rem',
        }}
      >
        <Card
          {...props}
          style={{
            padding: 0,
            width: props.flat ? '100% ' : (props.width ?? '43rem'),
            cursor: 'default',
          }}
        >
          {children}
        </Card>
      </div>
    );
  },
);

export default Object.assign(BaseCard, {
  Header,
  Body,
  Footer,
  DueDateBanner,
});
